// eslint-disable-next-line import/prefer-default-export
export const variant1 = 'variant1';
export const variant2 = 'variant2';
export const MODEL_CARD_GRID_USAGE = {
  INVENTORY: 'inventory',
  BAP: 'bap',
  UNKNOWN: 'unknown',
};

export const MODEL_CARD_GRID_USAGE_URLS = {
  [MODEL_CARD_GRID_USAGE.INVENTORY]: ['inventory', 'inventaire'],
};
